import { Suspense, lazy, Fragment } from "react";
import { Route, Routes } from "react-router-dom";
import Layout from "./layouts/Layout";

import PrivateRoute from "./routes/PrivateRoute";
import AdminRoute from "./routes/AdminRoute";
import SuperAdminRoute from "./routes/SuperAdminRoute";
import PublicOnlyRoute from "./routes/PublicOnlyRoute";

const ROUTES = [
  {
    path: "/login",
    Component: lazy(() => import("./pages/Login")),
    publicOnly: true,
  },
  {
    path: "*",
    Layout: Layout,
    routes: [
      {
        path: "/",
        Component: lazy(() => import("./pages/Home")),
      },
      {
        path: "posts",
        Component: lazy(() => import("./pages/ItemsPage/Post")),
      },
      {
        path: "post/:id",
        Component: lazy(() => import("./pages/Single/Post")),
      },
      {
        path: "posts/tag/:tag",
        Component: lazy(() => import("./pages/Tags/Post")),
      },
      {
        path: "posts/stats",
        Component: lazy(() => import("./pages/Stats/Post")),
      },
      {
        path: "posts/dashboard",
        Component: lazy(() => import("./pages/admin/Dashboard/Posts")),
        private: true,
        admin: true,
      },
      {
        path: "games",
        Component: lazy(() => import("./pages/ItemsPage/Game")),
      },
      {
        path: "game/:id",
        Component: lazy(() => import("./pages/Single/Game")),
      },
      {
        path: "games/tag/:tag",
        Component: lazy(() => import("./pages/Tags/Game")),
      },
      {
        path: "games/stats",
        Component: lazy(() => import("./pages/Stats/Game")),
      },
      {
        path: "games/dashboard",
        Component: lazy(() => import("./pages/admin/Dashboard/Games")),
        private: true,
        admin: true,
      },
      {
        path: "users",
        Component: lazy(() => import("./pages/ItemsPage/User")),
      },
      {
        path: "user/:id",
        Component: lazy(() => import("./pages/Single/User")),
      },
      {
        path: "users/dashboard",
        Component: lazy(() => import("./pages/admin/Dashboard/Users")),
        private: true,
        admin: true,
      },
      {
        path: "users/post-comments",
        Component: lazy(() => import("./pages/admin/Dashboard/PostComments")),
      },
      {
        path: "users/game-comments",
        Component: lazy(() => import("./pages/admin/Dashboard/GameComments")),
      },
      {
        path: "users/user-comments",
        Component: lazy(() => import("./pages/admin/Dashboard/UserComments")),
      },
      // {
      //   path: "users/badges",
      //   Component: lazy(() => import("./pages/admin/Dashboard/Badges")),
      //   private: true,
      //   admin: true,
      //   superadmin: true,
      // },
      {
        path: "profile",
        Component: lazy(() => import("./pages/Profile")),
        private: true,
      },
      {
        path: "notfound",
        Component: lazy(() => import("./pages/NotFound")),
      },
      {
        path: "authRedirect",
        Component: lazy(() => import("./components/TwitchCallback")),
      },
      {
        path: "support",
        Component: lazy(() => import("./pages/Support")),
      },
      {
        path: "post/tags/dashboard",
        Component: lazy(() => import("./pages/admin/Dashboard/Tags")),
        private: true,
        admin: true,
      },
      {
        path: "*",
        Component: lazy(() => import("./pages/NotFound")),
      },
    ],
  },
];

const renderRoutes = (routes) => {
  return (
    <>
      <Suspense fallback={<></>}>
        <Routes>
          {routes.map((route) => {
            const Private = route.private ? PrivateRoute : Fragment;
            const Admin = route.admin ? AdminRoute : Fragment;
            const SuperAdmin = route.superadmin ? SuperAdminRoute : Fragment;
            const PublicOnly = route.publicOnly ? PublicOnlyRoute : Fragment;
            const Component = route.Component;
            const Layout = route.Layout || Fragment;

            return (
              <Route
                path={route.path}
                key={route.path}
                element={
                  <SuperAdmin>
                    <Admin>
                      <Private>
                        <PublicOnly>
                          <Layout>
                            {route.routes ? (
                              renderRoutes(route.routes)
                            ) : (
                              <Component />
                            )}
                          </Layout>
                        </PublicOnly>
                      </Private>
                    </Admin>
                  </SuperAdmin>
                }
              />
            );
          })}
        </Routes>
      </Suspense>
    </>
  );
};

const RoutesBase = () => renderRoutes(ROUTES);

export default RoutesBase;
